import { createAction } from '@reduxjs/toolkit';

export const setPostList = createAction('post/setPostList');
export const setIsLoading = createAction('post/setIsLoading');
export const setTabsList = createAction('post/setTabsList');
